/* eslint-disable max-len */
import React, { Fragment } from 'react';

export default {
  financialStrengthRating: sup => ({
    title: <Fragment>A&#43;&#43;</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> financial strength rating</Fragment>,
    description: <Fragment>AAA, Aaa, and AA&#43; maintaining the highest financial strength ratings of any life insurer from all major rating agencies during this pandemic<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Awarded in the Insurance category: Life &amp; Health industry, <cite>Fortune&#174; Magazine&#39;s annual survey, 2017</cite></Fragment>,
  }),
  rankedInvestmentService: sup => ({
    title: <Fragment>Top 5</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> ranked investment service</Fragment>,
    description: <Fragment>ranked among the top U.S. Independent Investment Broker&#45;Dealers<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Ranking for Northwestern Mutual Investment Services LLC, <cite>Financial Advisor magazine and InvestmentNews, May 2020</cite></Fragment>,
  }),
  yearsOfService: () => ({
    title: <Fragment>160&#43;</Fragment>,
    blockquote: false,
    assistiveTitle: <Fragment> years strong through depressions, downturns, two world wars, and pandemics</Fragment>,
    description: <Fragment>years strong through depressions, downturns, two world wars, and pandemics</Fragment>,
    footer: null,
  }),
  dividend: sup => ({
    title: <Fragment>&#36;6.2B</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> in dividends expected to be paid in 2021</Fragment>,
    description: <Fragment>in dividends expected to be paid in 2021<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Dividends are reviewed annually and are not guaranteed.</Fragment>,
  }),
  rankedInsuranceCompany: sup => ({
    title: <Fragment>No. 1</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> overall&#45;ranked insurance company</Fragment>,
    description: <Fragment>Best Life Insurance Company ranked by NerdWallet, 2020<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Ranking for Northwestern Mutual Investment Services LLC, <cite>&#169;2017&#8211;2020 and TM, NerdWallet, Inc. All Rights Reserved.</cite></Fragment>,
  }),
  policyholderRetention: sup => ({
    title: <Fragment>96&#37;</Fragment>,
    blockquote: true,
    assistiveTitle: <Fragment> of our policyowners stay with us year over year.</Fragment>,
    description: <Fragment>of our policyowners stay with us year over year<sup>{sup}</sup></Fragment>,
    footer: <Fragment>Statistic for Northwestern Mutual, <cite>based on Northwestern Mutual policyowner data.</cite></Fragment>,
  }),
  moodysInvestorsService: sup => ({
    title: <Fragment>Aaa</Fragment>,
    blockquote: true,
    description: <Fragment><span className='nmx-uppercase'>Highest</span><br/>Moody&#39;s Investors Service<sup>{sup}</sup></Fragment>,
    footer: <Fragment><cite>December 2020</cite></Fragment>,
  }),
  AMBestCompany: sup => ({
    title: <Fragment>A&#43;&#43;</Fragment>,
    blockquote: true,
    description: <Fragment><span className='nmx-uppercase'>Highest</span><br/>A.M. Best Company<sup>{sup}</sup></Fragment>,
    footer: <Fragment><cite>April 2020</cite></Fragment>,
  }),
  fitchRatings: sup => ({
    title: <Fragment>AAA</Fragment>,
    blockquote: true,
    description: <Fragment><span className='nmx-uppercase'>Highest</span><br/>Fitch Ratings<sup>{sup}</sup></Fragment>,
    footer: <Fragment><cite>August 2020</cite></Fragment>,
  }),
  SPGlobalRatings: sup => ({
    title: <Fragment>AA&#43;</Fragment>,
    blockquote: true,
    description: <Fragment><span className='nmx-uppercase'>Second Highest</span><br/>S&#38;P Global Ratings<sup>{sup}</sup></Fragment>,
    footer: <Fragment><cite>June 2020</cite></Fragment>,
  }),
};
